export default __webpack_public_path__ + "static/media/co-win.abcaa24f.png";